import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaQuestionCircle } from 'react-icons/fa';

const FAQ = ({ isLightMode }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleCollapsible = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      question: 'What is the purpose of this site?',
      answer: 'The purpose of this site is to teach important concepts through interactive games that include quizzes. Players can test their knowledge while playing, receive immediate feedback on their answers, and compete on leaderboards to track their progress.',
    },
    {
      question: 'How can I use the features of the site?',
      answer: 'You can use the site by selecting a game to play, where quizzes will appear during gameplay to test your knowledge. You will receive feedback on your answers, earn points, and compete on leaderboards. You can also track your personal progress and compare your scores with others.',
    },
    {
      question: 'Is this site free to use?',
      answer: 'Yes, the site is completely free to use for all users. No hidden charges or premium plans.',
    },
    {
      question: 'Can I share my progress with others?',
      answer: 'Absolutely! You can share your progress via social media integrations available on the platform.',
    },
  ];

  return (
    <div className="py-16 md:py-24 bg-[var(--faq-background-color)]">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center justify-center mb-3">
            {/* Question mark icon - Now fixed blue in both themes for consistency and contrast */}
            <FaQuestionCircle 
              style={{
                color: "#1a56db", // Dark blue for high contrast in both themes
                marginRight: '0.75rem',
                fontSize: '2rem'
              }}
              className="text-3xl md:text-4xl mr-3"
            />
            <h2 className="text-4xl md:text-5xl font-bold text-[var(--faq-title-color)]">
              Frequently Asked Questions
            </h2>
          </div>
        </div>
        
        <div className="space-y-5">
          {faqData.map((faq, index) => (
            <div 
              key={index} 
              className={`rounded-lg overflow-hidden shadow-md transition-all duration-300 ${
                activeIndex === index ? 'ring-2 ring-[var(--interactive-color)]' : ''
              }`}
            >
              <button
                className={`w-full p-5 md:p-6 text-left text-lg md:text-xl font-medium flex justify-between items-center transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-[var(--focus-outline-color)] ${
                  activeIndex === index 
                    ? 'bg-[var(--interactive-color)] text-white' 
                    : 'bg-[var(--surface-color)] text-[var(--text-color)] hover:bg-[var(--surface-color-hover)]'
                }`}
                onClick={() => toggleCollapsible(index)}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <span className="pr-2">{faq.question}</span>
                <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full ${
                  activeIndex === index 
                    ? 'bg-white bg-opacity-20' 
                    : isLightMode 
                      ? 'bg-[var(--interactive-color)] bg-opacity-10' 
                      : 'bg-[var(--interactive-color)]'
                }`}>
                  {activeIndex === index ? (
                    <FaChevronUp className="text-white text-sm" />
                  ) : (
                    <FaChevronDown 
                      style={{
                        color: isLightMode ? "#1a56db" : "#ffffff" // Blue in light mode, white in dark mode
                      }}
                      className="text-sm" 
                    />
                  )}
                </span>
              </button>
              
              <div 
                id={`faq-answer-${index}`}
                className={`overflow-hidden transition-all duration-300 ${
                  activeIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
                aria-hidden={activeIndex !== index}
              >
                <div className={`p-5 md:p-6 md:text-lg leading-relaxed bg-[var(--background-color)] border-t border-[var(--border-color)] text-[var(--text-color)]`}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;